import { connect } from 'react-redux';
import React, {  useState } from "react";
import addDays from "date-fns/addDays";
import { useLocation, useParams } from 'react-router';



function useQuery() {
    return new URLSearchParams(useLocation().search);
}








const ActivatePassword = () => {
    let query = useQuery();

    const [newPassword, setNewPassword] = useState("");


    async function setPassword() {
        const response = await fetch('AdminPassword?action=activate&id=' + query.get("id") + "&password=" + newPassword);
        const data = await response.json();
        alert('' + data);
    }

    return (
        <div>
            <h1>Aktiver nyt kodeord</h1>
            <p>Vælg nyt kodeord:</p>
            <input type="text" value={newPassword} onChange={e => setNewPassword(e.target.value)}></input>
            <br /><br />
            <button onClick={setPassword} className="btn btn-success btn-sm">Sæt nyt kodeord</button>
            

        </div>
    );

};

export default connect()(ActivatePassword);


